import { Card } from '@blueprintjs/core';
import * as React from 'react';

interface Props {
    feedback: string;
};

interface State { }

export class SingleFeedbackView extends React.Component<Props, State> {

    state: State = {

    }


    render() {
        const { feedback } = this.props;

        let isJSON = false;
        let cardSets: any[] = [];

        try {
            const set = JSON.parse(feedback);

            const questions = Object.keys(set);

            for (let i = 0; i < questions.length; i++) {
                cardSets.push(
                    <Card className="singleFeedbackCard">
                        <h5>{questions[i]}</h5>
                        <p>{set[questions[i]].split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                        {index % 2 === 1 ? <strong>{line}</strong> : line}
                        <br />
                    </React.Fragment>
                ))}</p>
                    </Card>
                )
            }

            isJSON = true;
        }
        catch (err) {

        }

        if (isJSON) {
            return <div>{cardSets}</div>
        }
        else {
            return <p>{feedback.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                    {index % 2 === 1 ? <strong>{line}</strong> : line}
                    <br />
                </React.Fragment>
            ))}</p>
        }
    }
}
